import {Component, ErrorInfo, lazy, Suspense, type ReactNode} from 'react'
import {Redirect} from 'react-router-dom'
import Logger from 'services/Logger'

const Modal = lazy(() => import('components/Basic/Modal'))
interface ErrorBoundaryProps {
  children: ReactNode
}

export class ErrorBoundary extends Component<ErrorBoundaryProps> {
  state = {hasError: false, redirect: false}

  static getDerivedStateFromError(error: Error | null): {
    hasError: boolean
    error: Error | null
  } {
    return {hasError: true, error}
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    Logger.LogUncaughtError(error, errorInfo)
  }

  render(): React.ReactNode {
    if (this.state.redirect) {
      return <Redirect to="/" />
    }

    return this.state.hasError ? (
      <div>
        <Suspense fallback={<div />}>
          <Modal
            messageType="error"
            message="Something went wrong. Our engineering team will sort this out shortly"
            isOpen={true}
            buttonFn={() => {
              window.location.href = '/'
            }}
          />
        </Suspense>
      </div>
    ) : (
      this.props.children
    )
  }
}
